module.exports = __webpack_public_path__ + "static/media/Mordekaiser_0.ff8b2aa9.jpg";